import type { IOrganizationRepository } from "@/application/ports/repositories";
import type { ITokenService } from "@/application/ports/services/ITokenService";
import type { IOrgStorageService } from "@/application/ports/services/IOrgStorageService";

export class SwitchOrganizationUseCase {
	constructor(
		private orgRepo: IOrganizationRepository,
		private tokenService: ITokenService,
		private orgStorageService: IOrgStorageService,
	) {}

	async execute(
		organizationUuid: string,
	): Promise<{ success: boolean; error?: string }> {
		try {
			if (!organizationUuid) {
				return { success: false, error: "Organization UUID is required" };
			}

			const data = await this.orgRepo.switchOrganization(organizationUuid);

			// Token management
			if (data?.access_token) {
				this.tokenService.setToken(data.access_token);
				if (data.refresh_token) {
					this.tokenService.setRefreshToken(data.refresh_token);
				}
			}

			// Persist selected org
			this.orgStorageService.setCurrentOrgUuid(organizationUuid);

			return { success: true };
		} catch (error) {
			return {
				success: false,
				error:
					error instanceof Error
						? error.message
						: "Failed to switch organization",
			};
		}
	}
}
